<template>
	<sa-page-layout :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh">
		<template slot="toolbar-title">Gestione Assistiti</template>
		<template slot="table-filter">
			<b-form @submit.prevent="onSubmit">
				<b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
					<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
						<label class="sa-label-data">Cognome:</label>
						<b-form-input v-model="filtroGestioneAssistiti.cognome" type="search" id="cognome" placeholder="Cognome"></b-form-input>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
						<label class="sa-label-data">Nome:</label>
						<b-form-input v-model="filtroGestioneAssistiti.nome" type="search" id="nome" placeholder="Nome"></b-form-input>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
						<label class="sa-label-data">Identificativo:</label>
						<b-form-input v-model="filtroGestioneAssistiti.identificativo" type="search" id="identificativo" :placeholder="this.$i18n.t('adi.lblFiscalCode')"></b-form-input>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
						<label class="sa-label-data">Stato:</label>
						<b-form-input v-model="filtroGestioneAssistiti.stato" type="search" id="stato" placeholder="Stato"></b-form-input>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
						<label class="sa-label-data">Presidio:</label>
						<b-form-select v-model="filtroGestioneAssistiti.idPresidio" :options="presidiOptions" :value="null" value-field="value" text-field="text" @change="onChangePresidio"></b-form-select>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
						<label class="sa-label-data">Regime:</label>
						<b-form-select v-model="filtroGestioneAssistiti.regime" :options="regimeOptions" :value="null" value-field="codice" text-field="descrizione"></b-form-select>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
						<label class="sa-label-data">Setting/Reparto:</label>
						<b-form-select v-model="filtroGestioneAssistiti.settingCodice" :options="settingsPresidiOptions" :value="null" value-field="codice" text-field="setting"></b-form-select>
					</b-col>
				</b-row>
				<b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
					<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
						<b-button type="submit" variant="info">Cerca</b-button>
						<b-button type="reset" v-on:click="onReset" variant="danger">Reset</b-button>
					</b-col>
				</b-row>
			</b-form>
		</template>
		<template slot="table-body">
			<rsa-gestione-assistiti-list-component ref="cmpRsaGestioneAssistitiListComponent"></rsa-gestione-assistiti-list-component>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PresidiMixin from "../../../strutture/mixins/PresidiMixin";
import RsaGestioneAssistitiListComponent from "../components/RsaGestioneAssistitiListComponent.vue";
import RegimiMixin from "../../rsaconfigurazione/mixins/RegimiMixin";
import SettingsPresidiMixin from "../../rsaconfigurazione/mixins/SettingsPresidiMixin";
export default {
	mixins: [PresidiMixin, RegimiMixin, SettingsPresidiMixin],
	components: { SaPageLayout, RsaGestioneAssistitiListComponent },
	data() {
		return {
			statoOptions: [],
			filtroGestioneAssistiti: { cognome: null, nome: null, identificativo: null, stato: null, idPresidio: null, regime: null, settingCodice: null },
		};
	},
	mounted() {
		this.settingsPresidiLoadData();
		this.regimiLoadData();
		this.presidiLoadData();
		this.loadAssistiti();
	},
	methods: {
		loadAssistiti() {
			let sessionStorage = window.sessionStorage;
			sessionStorage["filtroGestioneAssistiti"] = JSON.stringify(this.filtroGestioneAssistiti);
			this.$refs.cmpRsaGestioneAssistitiListComponent.loadAssistiti();
		},
		onRefresh() {},
		onChangePresidio() {},
		onReset() {
			//this.$refs.cmpRsaGestioneAssistitiListComponent.reset();
			this.filtroGestioneAssistiti = { cognome: null, nome: null, identificativo: null, stato: null, idPresidio: null, regime: null, settingCodice: null };
			this.loadAssistiti();
		},
		onSubmit() {
			this.loadAssistiti();
		},
	},
};
</script>

<style></style>
